"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("$debounce", function ($timeout) {
  /**
   * @ngdoc service
   * @name $debounce
   *
   * @description
   * Angular's $timeout wrapper around the 'debounce' approach (such as in underscore).
   * The 'fn' function will be asynchronously executed only after 'wait' ms without consecutive calls.
   * rootScope.$apply will be called after method execution, except if 'invokeApply' is false.
   *
   * @param {function()} [fn] A function to debounce.
   * @param {number=}  [wait] The debounce duration in milliseconds.
   * @param {boolean=} [invokeApply=true] If set to 'false', skips the {@link ng.$rootScope.Scope#$apply `$applỳ} call.
   *
   * @returns {function()} The debounced function wrapper.
   *                      The wrapper has a 'cancel' method attribute, which can be called to cancel the currently pending debounce.
   */
  function $debounce(fn, wait, invokeApply) {
    var timeoutPromise;
    function cancel() {
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
        timeoutPromise = null;
      }
    }
    function debouncedWrapper() {
      var self = this,
        args = arguments;
      cancel();
      timeoutPromise = $timeout(function () {
        fn.apply(self, args);
      }, wait, invokeApply);
    }
    debouncedWrapper.cancel = cancel;
    return debouncedWrapper;
  }
  return $debounce;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/$debounce.js
// module id = 2739
// module chunks = 13